//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';
import * as userApi from '~/api/user';
import * as types from '~/types';

export default {
  props: {
    subjectId: {
      type: Number,
      default: 0,
    },
    isFollow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', ['isFocus', 'isLogin', 'userId']),
  },
  methods: {
    focus() {
      if (!this.isLogin) {
        this[types.SHOW_LOGIN_FORM]();
        return;
      }
      this.$axios(
        userApi.focusTheme({
          subjectId: this.subjectId,
        })
      )
        .then((res) => {
          if (res.statusCode === 200) {
            this.$emit('success');
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    unfocus() {
      if (!this.isLogin) {
        return;
      }
      this.$axios(
        userApi.cancelTheme({
          subjectId: this.subjectId,
        })
      )
        .then((res) => {
          if (res.statusCode === 200) {
            this.$emit('success');
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    onClick() {
      if (this.isFollow) {
        this.unfocus();
      } else {
        this.focus();
      }
    },
    ...mapMutations('user', [
      types.FOCUS,
      types.UNFOCUS,
      types.SHOW_LOGIN_FORM,
    ]),
  },
};
